import { createRouter, createWebHashHistory, type RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  { path: '/', name: 'landing', component: () => import('./views/LandingView.vue') },
  { path: '/thread-dump', name: 'thread-dump', component: () => import('./views/ThreadDumpView.vue') },
  { path: '/thread-dump/multi', name: 'multi-dump', component: () => import('./views/MultiDumpView.vue') },
  { path: '/batch', name: 'batch', component: () => import('./views/BatchAnalysisView.vue') },
  { path: '/gc-log', name: 'gc-log', component: () => import('./views/GcLogView.vue') },
  { path: '/tuning-rules', name: 'tuning-rules', component: () => import('./views/TuningRulesView.vue') },
  { path: '/trends', name: 'trends', component: () => import('./views/TrendsView.vue') },
  { path: '/feedback', name: 'feedback', component: () => import('./views/FeedbackView.vue') },
  { path: '/refund-policy', name: 'refund-policy', component: () => import('./views/RefundPolicyView.vue') },
  { path: '/terms', name: 'terms', component: () => import('./views/TermsOfServiceView.vue') },
  { path: '/about/privacy', name: 'privacy', component: () => import('./views/PrivacyView.vue') },
  { path: '/activate', name: 'activate', component: () => import('./views/ActivateView.vue') },
];

export const router = createRouter({
  history: createWebHashHistory(),
  routes,
});
